<div class="devmode-indicator">
  <button [stbButton]="'secondary'" [size]="'small'" [rebrand]="true" (click)="openDevPanel()">
    {{ devModeIndicator$ | async }}
  </button>
</div>
<app-ai-mock-chat />
